import "./page.css"

import EventEmitter from "eventemitter3";
import { Data } from "../../models/data";
import { Context } from "../../models/context";
import { LocalizationService } from "../../services/localization-service";

export abstract class Page {
    protected _id: string;
    protected _element: HTMLElement | null;
    protected _eventBus: EventEmitter;
    protected _data: Data;
    protected _context: Context;
    protected _localizationService: LocalizationService;

    constructor(id: string, eventBus: EventEmitter, data: Data, context: Context, localizationService: LocalizationService) {
        this._id = id;
        this._element = null;
        this._eventBus = eventBus;
        this._data = data;
        this._context = context;
        this._localizationService = localizationService;
    }

    public init(): void {
        this._element = document.getElementById(this._id);
        this.hide();
    }

    public abstract initAsync(): Promise<void>;

    public show(): void {
        if (this._element) {
            this._element.classList.toggle("open", true);
            this._element.role = "main";
        }
    }

    public hide(): void {
        if (this._element) {
            this._element.classList.toggle("open", false);
            this._element.role = null;
        }
    }
}